import Vue from 'vue';

import './styles/quasar.scss';
import '@quasar/extras/material-icons/material-icons.css';
import Quasar from 'quasar/src/vue-plugin.js';import Dialog from 'quasar/src/plugins/Dialog.js';;

import he from 'quasar/lang/he';

Vue.use(Quasar, {
  lang: he,
  config: {},
  plugins: [
    Dialog,
  ],
});
